export const Footer = () => {
    return (
        <div id="footer">
            <div className="anchor"></div>
            <div className='container text-center'>
                <p>&copy; 2022 PizzaMafiaPals. Design by{' '}
                <a href='http://www.rollyk.com' rel='nofollow'>
                    Rollyk
                </a>
                </p>
            </div>
        </div>
    );
  };
  